import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild} from '@angular/core';

import {AuthService} from '../auth.service';
import {NotificationService} from '../notification.service';
import { HttpErrorResponse } from '@angular/common/http';
import {StripHtmlPipe} from '../strip-html.pipe';
import {RouterLink} from '@angular/router';
import {OauthLinkComponent} from '../oauth-link/oauth-link.component';
import {NgbPopover} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule} from '@angular/forms';
import { AsyncPipe } from '@angular/common';
import {Observable} from 'rxjs';


@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    imports: [FormsModule, NgbPopover, OauthLinkComponent, RouterLink, StripHtmlPipe, AsyncPipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginComponent implements OnInit {

    model: any = {};
    loading = false;
    loggedIn$: Observable<boolean>;

    @ViewChild('loginError')
    loginErrorTemplate: TemplateRef<any>;

    constructor(private notificationService: NotificationService,
                private authenticationService: AuthService,
                private cdr: ChangeDetectorRef) {
    }


    ngOnInit() {
        this.loggedIn$ = this.authenticationService.loggedIn$;
    }

    logout() {
        this.authenticationService.logout();
    }

    login() {
        this.loading = true;
        this.cdr.markForCheck();
        this.authenticationService.login(this.model.username, this.model.password)
            .then(_data => {
                this.model.username = '';
                this.model.password = '';
                this.loading = false;
                this.cdr.markForCheck();
            }).catch(error => {
            this.loading = false;
            this.notificationService.forTemplate('Login failed!', this.loginErrorTemplate, {
              error: error instanceof HttpErrorResponse ? error.error : error.message
            });
            this.cdr.markForCheck();
        });
    }

}
